import { useState } from "react";
import { Share2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { SPORT_LABEL } from "@/lib/format";

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
};

export async function buildCard({ name, bib, category, sport, date, time, site = "www.runcemoc.com" }) {
  const W = 1080, H = 1350;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0B1A10"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#2FA34B"; ctx.fillRect(0, 0, W, 18);
  ctx.fillStyle = "#A3E635"; ctx.fillRect(0, H - 18, W, 18);

  const [logo, seal] = await Promise.all([loadImg("/logo-cemoc.png"), loadImg("/selo-15-anos.png").catch(() => null)]);
  ctx.fillStyle = "#fff"; roundRect(ctx, 80, 80, 300, 250, 32); ctx.fill();
  ctx.drawImage(logo, 95, 90, 270, 230);
  if (seal) ctx.drawImage(seal, W - 80 - 300, 70, 300, 220);

  ctx.textAlign = "center"; ctx.fillStyle = "#fff";
  ctx.font = "900 34px Inter, Arial"; ctx.letterSpacing = "6px";
  ctx.fillText("ESTOU CONFIRMADO NA", W / 2, 430);
  ctx.font = "900 92px Inter, Arial"; ctx.letterSpacing = "0px";
  ctx.fillText("1ª CEMOC RUN", W / 2, 540);
  ctx.fillStyle = "#2FA34B"; ctx.fillText("COARI 2026", W / 2, 640);

  ctx.fillStyle = "#132A1C"; roundRect(ctx, 80, 700, W - 160, 420, 36); ctx.fill();
  ctx.strokeStyle = "#2FA34B"; ctx.lineWidth = 4; ctx.stroke();
  ctx.fillStyle = "#9CB3A3"; ctx.font = "700 26px Inter, Arial"; ctx.letterSpacing = "5px";
  ctx.fillText("NÚMERO DE PEITO", W / 2, 770);
  ctx.fillStyle = "#A3E635"; ctx.font = "900 120px 'Courier New', monospace"; ctx.letterSpacing = "8px";
  ctx.fillText(bib, W / 2, 900);
  ctx.letterSpacing = "0px";
  ctx.fillStyle = "#fff"; ctx.font = "800 46px Inter, Arial";
  const n = name.length > 26 ? name.slice(0, 25) + "…" : name;
  ctx.fillText(n.toUpperCase(), W / 2, 990);
  ctx.fillStyle = "#2FA34B"; ctx.font = "700 32px Inter, Arial";
  ctx.fillText(`${SPORT_LABEL[sport] || sport} • ${category}`, W / 2, 1050);

  ctx.fillStyle = "#fff"; ctx.font = "900 56px Inter, Arial";
  ctx.fillText(`${date} • ${time}h`, W / 2, 1220);
  ctx.fillStyle = "#9CB3A3"; ctx.font = "600 28px Inter, Arial";
  ctx.fillText(`Inscrições: ${site}`, W / 2, 1280);

  return new Promise((res) => c.toBlob(res, "image/png"));
}

export const ShareCard = ({ reg, runner, event }) => {
  const [busy, setBusy] = useState(false);
  const share = async () => {
    setBusy(true);
    try {
      const date = event?.event_date ? new Date(event.event_date + "T00:00:00").toLocaleDateString("pt-BR") : "08/11/2026";
      const blob = await buildCard({ name: runner?.full_name || "", bib: reg.bib_code, category: reg.category?.name || "",
        sport: reg.category?.sport_type, date, time: event?.event_time || "17:30", site: event?.site_url || "www.runcemoc.com" });
      const file = new File([blob], `cemoc-run-${reg.bib_code}.png`, { type: "image/png" });
      const text = `Estou confirmado na 1ª CEMOC RUN COARI 2026! Número de peito ${reg.bib_code} 🏃‍♂️ Inscreva-se também: ${event?.site_url || "www.runcemoc.com"}`;
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], text, title: "CEMOC RUN 2026" });
      } else {
        const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
        toast.success("Card baixado! Anexe a imagem no WhatsApp.");
      }
    } catch (e) { if (e?.name !== "AbortError") toast.error("Não foi possível gerar o card."); }
    finally { setBusy(false); }
  };
  return (
    <Button data-testid={`share-btn-${reg.bib_code}`} onClick={share} disabled={busy}
      className="bg-[#25D366]/20 text-[#5EF08F] border border-[#25D366]/40 hover:bg-[#25D366]/30 font-bold">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Share2 className="w-4 h-4 mr-2" /> Compartilhar no WhatsApp</>}
    </Button>
  );
};

export default ShareCard;
